<template>
  <div class="min-h-screen w-full h-full flex flex-col">
    <!-- 使用布局组件 -->
    <AdminLayout v-if="showLayout">
      <router-view />
    </AdminLayout>

    <!-- 登录页面直接显示，不使用布局 -->
    <router-view v-if="!showLayout" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AdminLayout from './layouts/AdminLayout.vue';

// 获取当前路由
const route = useRoute();

// 计算是否显示布局
const showLayout = computed(() => {
  return route.meta.requiresAuth !== false;
});
</script>

<style>
@import './assets/css/main.css';

html, body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
}

* {
  box-sizing: border-box;
}

#app {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}
</style>